/******************************************************
 *                  Open-iti export
 ********************************************************/

"use strict";

angular.module("open-iti")

	.controller("OpenPublicationCtrl", [
		"$scope", "toastr", "publication", "Utils", "$uibModal", "OpenPublicationService", "$controller",
		function ($scope, toastr, publication, Utils, $uibModal, OpenPublicationService, $controller) {

		$controller("OpenPublicationCtrlParent", {$scope: $scope});

		$scope.data = {
			publications : publication.data
		};
      
	}]);
